import { IBakpakCodes } from "@app/account/account.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const bakpakCodesAdapter: EntityAdapter<IBakpakCodes> = createEntityAdapter<IBakpakCodes>({
	selectId: address => address.userId
});